import React from "react";
import { useStores } from "../../hooks/useStores";
import GAIStrokeRecognizer from "@views/assignments/manage/OfflineSubmissions/CompareNeoPenData/GAIStrokeRecognizer";
import { IPageSOBP, NeoStroke } from "../../neolab-libs/nl-lib3-common";
import { IExamInfo } from "@repositories/model/transfer/IExamInfo";
import { IProject } from "@repositories/model/IProject";

export const codeToRecognizedTextPromise = {} as { [key: string]: Promise<string> };

export type IOcrResult = {
	recognizedText: string,
	ocrStatus: "none" | "requested" | "done" | "error"
};


function useStrokeRecognitionWithGAI() {
	
	const [codeToOcrResultWithAI, setCodeToRecognizedText] = React.useState<{ [key: string]: IOcrResult }>({});
	const [numRequestedWithAI, setNumRequested] = React.useState(0);
	const [numDoneWithAI, setNumDone] = React.useState(0);

	const [wholeStrokes, setWholeStrokes] = React.useState<NeoStroke[]>([]);
	const [nCodeRange, setNCodeRange] = React.useState<{ start: IPageSOBP, end: IPageSOBP }>(null);
	const [examInfoArray, setExamInfoArray] = React.useState<IExamInfo[]>([]);

	const putOfflineStrokesToRecognizeWithAI = (strokes: NeoStroke[], ncodeRange: { start: IPageSOBP, end: IPageSOBP }, examInfoArray: IExamInfo[]) => {
		setWholeStrokes(strokes);
		setNCodeRange(ncodeRange);
		setExamInfoArray(examInfoArray);
	}

	React.useEffect(() => {
		// Guard: require all inputs
		if (!wholeStrokes || wholeStrokes.length === 0) return;
		if (!nCodeRange) return;
		if (!examInfoArray || examInfoArray.length === 0) return;

		(async () => {
			try {
				const recognizer = new GAIStrokeRecognizer();
				recognizer.wholeStrokes = wholeStrokes;
				recognizer.ncodeRange = nCodeRange;
				recognizer.examInfoArray = examInfoArray;

				const recognizedMap = await recognizer.recognize(); // Record<code, string>

				const next: { [key: string]: IOcrResult } = {};
				Object.keys(recognizedMap).forEach((code) => {
					next[code] = { recognizedText: recognizedMap[code] ?? "", ocrStatus: "done" };
				});
				setCodeToRecognizedText(next);

				// Leave counters simple for now
				setNumRequested(Object.keys(next).length);
				setNumDone(Object.keys(next).length);
			} catch (e) {
				console.error(e);
			}
		})();
	}, [wholeStrokes, nCodeRange, examInfoArray]);

	return { codeToOcrResultWithAI, numRequestedWithAI, numDoneWithAI, putOfflineStrokesToRecognizeWithAI };
}

export default useStrokeRecognitionWithGAI;